import styled from 'styled-components'

export const Root = styled.div`display: grid; gap: 28px;`
export const KpiSkeletons = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-block: 1px solid ${p => p.theme.palette.colors.borderSoft};
  @media (max-width: 920px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 480px) { grid-template-columns: 1fr; }
`
export const KpiSkeleton = styled.div`
  display: grid;
  min-height: 105px;
  align-content: center;
  gap: 12px;
  padding: 20px;
  border-right: 1px solid ${p => p.theme.palette.colors.borderSoft};
`
export const ChartSkeleton = styled.div`display: grid; gap: 18px;`
export const SectionSkeleton = styled.div`display: grid; gap: 14px;`
